import { render, staticRenderFns } from "./Obsoleted.vue?vue&type=template&id=78b28ff8&scoped=true&"
import script from "./Obsoleted.vue?vue&type=script&lang=js&"
export * from "./Obsoleted.vue?vue&type=script&lang=js&"
import style0 from "./Obsoleted.vue?vue&type=style&index=0&id=78b28ff8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b28ff8",
  null
  
)

export default component.exports